export default __webpack_public_path__ + "img/tab1and2_nav3-1-a5336c2a.png";